<template>
  <div class="w-full bg-white flex flex-col items-start justify-start">
    <h1
      class="text-primary font-semibold text-4xl whitespace-pre-line text-start mt-10 w-full"
    >
      Herzlich Willkommen zu Deinem Kurs:<br />{{ GET_COURSE.name }}
    </h1>
    <div
      class="manual-container text-base text-black   whitespace-pre-line text-start mt-8"
      v-html="courseManualText"
    ></div>
    <custom-button
      @click="UPDATE_MANUAL"
      class="w-72 h-11 mt-10"
      :text="'Anleitung gelesen'"
      :bgColor="'bg-primary'"
      :textColor="'text-white'"
      :id="'manual-read-button'"
    />
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import sanitizeHtml from "sanitize-html";
import { useStore } from "vuex";
import { getData } from "../../../common/dataHelper";
import CustomButton from "../../../components/input/CustomButton.vue";
import {
  COURSE_TYPES,
  HELPER_TYPES,
  SLIDE_TYPES,
  STORE_TYPES,
} from "../../../store/types";

export default defineComponent({
  components: { CustomButton },
  setup() {
    const store = useStore();
    /**
     *  State
     */
    const state = reactive({});
    /**
     *  Functions
     */
    async function UPDATE_MANUAL() {
      store.commit(
        `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
        "manual-read-button"
      );
      const response = await store.dispatch(
        `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.UPDATE_MANUAL}`,
        {}
      );
      store.commit(
        `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
        "manual-read-button"
      );
      if (getData(response, "status") == 204) {
        store.commit(`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`, null);
        store.commit(
          `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
          "targetAgreement"
        );
      }
    }
    /**
     *  Computed
     */
    const GET_COURSE = computed(
      () => store.getters[`${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`]
    );

    const courseManualText = computed(() => {
      return sanitizeHtml(GET_COURSE.value.manual.text, {
        allowedAttributes: {
          ...sanitizeHtml.defaults.allowedAttributes,
          p: ["style"],
          h1: ["style"],
          h2: ["style"],
          h3: ["style"],
          h4: ["style"],
        },
      });
    });

    /**
     *  Created
     */

    return { state, UPDATE_MANUAL, GET_COURSE, courseManualText };
  },
});
</script>

<style>
.manual-container > * + * {
  margin-top: 0.75em;
}

.manual-container h1 {
  font-size: 2em;
  font-weight: bold;
  line-height: initial;
}

.manual-container h2 {
  font-size: 1.5em;
  font-weight: bold;
  line-height: initial;
}

.manual-container h3 {
  font-size: 1.3em;
  font-weight: bold;
  line-height: initial;
}

.manual-container h4 {
  font-size: 1em;
  font-weight: bold;
  line-height: initial;
}

.manual-container ul {
  padding: 0 2rem;
  list-style-type: disc;
}

.manual-container ul ul {
  padding: 0 2rem;
  list-style-type: circle;
}

.manual-container ul ul ul {
  padding: 0 2rem;
  list-style-type: square;
}

.manual-container ol {
  padding: 0 2rem;
  list-style-type: decimal;
}

.manual-container ol ol {
  padding: 0 2rem;
  list-style-type: lower-latin;
}

.manual-container ol ol ol {
  padding: 0 2rem;
  list-style-type: lower-roman;
}
</style>
